import React from 'react';

export default function Research({ pub }) {
  const projects = [
    {
      img: `${pub}/images/Diffusion_7ntk.gif`,
      title: 'Generative Protein Design',
      desc: "Designing novel proteins using diffusion and 'inverse-folding' models towards polypeptide and non-polypeptide targets.",
    },
    {
      img: `${pub}/images/GH29_mutate.gif`,
      title: 'Protein Sequence Redesign',
      desc: "Redesigning protein sequences to enhance stability and function using deep learning models.",
    },
    {
      img: `${pub}/images/Figure2.2.png`,
      title: 'Previous work: T cell receptor structural pipeline',
      desc: "Developed a comprehensive structural pipeline for T cell receptors, enabling efficient modeling and analysis.",
    },
    {
      img: `${pub}/images/SARS_CoV_2_Real_3.png`,
      title: 'Previous work: SARS-CoV-2 Decoy Inhibitor',
      desc: "Designed a decoy inhibitor for SARS-CoV-2 that showed effective results in both biochemical and cell-based assays.",
    },
  ];

  return (
    <section id="research" className="section research-section">
      <h2>Research</h2>
      <div className="projects">
        {projects.map((p, i) => (
          <div className="project" key={i}>
            <img src={p.img} alt={p.title} />
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
